import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SmallTagOutline } from '@/components/ui/Tag/SmallTagOutline';
export const RfpProfessionalNegotiableTag = (props) => {
    const { className = '' } = props;
    return (_jsx(SmallTagOutline, Object.assign({ className: className, color: 'positive' }, { children: "\u76F8\u8AC7\u53EF" })));
};
